<template>
	<div v-if="single" :id="attributeName + '__area'">
		<div data-attribute-type="single" :class="getColumnClass()" data-attribute-index="0">
			<div :class="SINGLE_ATTRIBUTE + ' ' + PREV_VALUES_DICT_CLASS">
				<div class="col-sm-5">
					<AttributeLabel
						:attributeName="attributeName"
						:localizedTitle="localizedTitle"
						:is-primary="isPrimary"
						:is-multiple="isMultiple"
						:max-count="maxCount"
						:sl-attribute="false"
						:enable-copy-attribute-name="enableCopyAttributeName"
						:is-prev="true"
						:locked-edit="lockedEdit"
					/>
				</div>
				<div class="col-sm-7">
					<PrevValuesDictionaryList
						:attributeName="attributeName"
						:is-multiple="isMultiple"
						:max-length="maxLength"
						:prev-values-dictionary="prevValuesDictionary"
						:item-data="itemData"
						:locked-edit="lockedEdit"
					/>
				</div>
			</div>
		</div>
	</div>
	<div v-else data-attribute-type="single" :class="getColumnClass()" data-attribute-index="0">
		<div :class="SINGLE_ATTRIBUTE + ' ' + PREV_VALUES_DICT_CLASS">
			<PrevValuesDictionaryList
				:attributeName="attributeName"
				:is-multiple="isMultiple"
				:max-length="maxLength"
				:prev-values-dictionary="prevValuesDictionary"
				:item-data="itemData"
				:locked-edit="lockedEdit"
			/>
			<button v-if="!lockedEdit" class="button_minus fa fa-minus right-float-button" tabindex="-1"></button>
		</div>
	</div>
</template>

<script>
import AttributeLabel from './AttributeLabel'
import PrevValuesDictionaryList from './PrevValuesDictionaryList'
import defaultClassManager from '../../mixins/defaultClassManager'
import { Fragment } from 'vue-fragment'

export default {
	components: {
		AttributeLabel,
		Fragment,
		PrevValuesDictionaryList
	},
	mixins: [defaultClassManager],
	name: 'SPrevValuesDictionaryEditor',
	props: [
		'attributeName',
		'localizedTitle',
		'isMultiple',
		'isPrimary',
		'maxLength',
		'maxCount',
		'defaultValue',
		'defaultLock',
		'colspan',
		'language',
		'prevValuesDictionary',
		'enableCopyAttributeName',
		'itemData',
		'lockedEdit'
	],
	data () {
		return {
			single: !this.isMultiple,
			SINGLE_ATTRIBUTE: 'single-attribute',
			PREV_VALUES_DICT_CLASS: 'pr-val-dict'
		}
	},
	computed: {
		attributeValue: function () {
			return this.itemData
		}
	}
}
</script>

<style scoped>

</style>
